// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { provideJupyterDesignSystem, jpSliderLabel } from '@jupyter/web-components';
import { provideReactWrapper } from '@microsoft/fast-react-wrapper';
import React from 'react';
const { wrap } = provideReactWrapper(React, provideJupyterDesignSystem());
export const SliderLabel = wrap(jpSliderLabel());
// @ts-expect-error unknown property
SliderLabel.displayName = 'Jupyter.SliderLabel';
